export const actionTabs = [
  {
    id: "0",
    content: "1. Choose your action"
  },
  {
    id: "1",
    content: "2. Select your products"
  },
  {
    id: "2",
    content: "3. Type and options"
  },
  {
    id: "3",
    content: "4. Advanced settings"
  }
];
